import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { IRoarAssignmentForm } from '../../../shared/models/roarAssignmentForm';
import { IAssessCase } from '../../../shared/models/assessCase';
import { RoarAssignmentFormService } from '../../../shared/services/roarAssignmentForm.service';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { EYesNo } from '../../../shared/models/types.enum';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ReviewRoarComponent } from '../review-content/review-roar/review-roar.component';
import { ReviewRoarActivityComponent } from '../review-content/review-roar-activity/review-roar-activity.component';
import { ReviewRoarActivityReviewComponent } from '../review-content/review-roar-activity-review/review-roar-activity-review.component';
import { PopupMessageComponent } from '../popup-message/popup-message.component';

@Component({
  selector: 'roar-modal',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    ReviewRoarComponent,
    ReviewRoarActivityComponent,
    ReviewRoarActivityReviewComponent,
    PopupMessageComponent
  ],
  templateUrl: './roar-modal.component.html',
  styleUrl: './roar-modal.component.css'
})
export class RoarModalComponent implements OnInit {
  @Input() assessCase: IAssessCase | null = null;

  @Output() onCreateNewRoar = new EventEmitter<any>();
  @Output() goToForm = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<void>();

  icons = Icons;
  yesNo = EYesNo;
  allRoarAssignments: IRoarAssignmentForm[] = [];
  selectedRoarAssignment: IRoarAssignmentForm | null = null;
  currentBuildingId: string | null = null;
  currentUserId: number | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;

  loading: boolean = false;

  constructor(
    private roarAssignmentFormService: RoarAssignmentFormService,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUserId = this.userDataService.getCurrentUser()?.user_id || null;
    
    if (this.assessCase) {
      this.loadAllRoarAssignments(this.assessCase.case_id);
    }
  }
  
  loadAllRoarAssignments(caseId: string): void {
    if (this.currentBuildingId && caseId) {
      this.loading = true;
      this.roarAssignmentFormService.getRoarAssignmentFormByCaseId(caseId).subscribe({
        next: (response) => {
          this.loading = false;
          this.allRoarAssignments = response;
        },
        error: (error) => {
          this.loading = false;
          this.messageModal = 'unsuccess';
          this.popupMessage = error.message;
          console.error('Error fetching ROAR assignments:', error);
        }
      });
    }
  }

  createRoarAssignmentForm(clickedCase: IAssessCase): void {
    if (this.assessCase && this.currentBuildingId) {
      this.loading = true;
      const fullData: any = {};
      fullData.case_id = clickedCase.case_id!;
      fullData.building_id = Number(this.currentBuildingId);
      this.roarAssignmentFormService.createRoarAssignmentForm(fullData).subscribe({
        next: (response) => {
          this.loading = false;
          this.onCreateNewRoar.emit({'type': 'success', 'message': response});
          this.onFormClick('form/roar-assignment-form', clickedCase.case_id, response.roar_id);
        },
        error: (error) => {
          this.loading = false;
          this.onCreateNewRoar.emit({'type': 'failed', 'message': error.message});
          console.error('Error creating roar assignment form:', error);
        }
      });
    }
  }

  onFormClick(page: string, caseId: string, roarId: string): void {
    this.goToForm.emit({ page, caseId, roarId });
  }

  onViewFormOpen(roarAssignment: IRoarAssignmentForm): void {
    if (roarAssignment.roar_id) {
      this.selectedRoarAssignment = roarAssignment;
    }
  }

  onCloseClick(): void {
    this.onClose.emit();
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
}
